// extracted by mini-css-extract-plugin
export default {"legalNotice":"_12tjf6dxQxDpR7zyEV2zGB"};